import React from 'react';
import { Masonry } from '@mui/lab';
import { Box } from '@mui/material';
import { ALLIMAGES_URL } from '../config/apiConfig';

function MasonryImagesPage() {
    const [images, setImages] = React.useState('');

  
  React.useEffect(() => {
    // Petición al servidor
    fetch(ALLIMAGES_URL)
      .then(response => response.json())
      .then(data => {
        setImages(data.images); // Asegúrate de que el backend devuelve "images"
      })
      .catch(error => {
        console.error('Error al obtener las imágenes:', error);
      });
  }, []);

  return (
    <div className="masonry-images-page" style={{ padding: '16px' }}>
      <h1 style={{ marginBottom: '16px' }}>Galería de Imágenes</h1>
      {images.length > 0 ? (
        <Masonry columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} spacing={2}>
          {images.map((image, index) => (
            <Box key={index}>
              <img
                src={image}
                alt={`Imagen ${index}`}
                style={{
                  width: '100%',
                  display: 'block',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}
              />
            </Box>
          ))}
        </Masonry>
      ) : (
        <p className="loading">Cargando imágenes...</p>
      )}
    </div>
  );
}

export default MasonryImagesPage;
